export class MapDescription {
    constructor(node, props) {
        this.node = node;
        this.props = props;
    }
}
